// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__oGkpY","errorLogs":"styles_errorLogs__cR7lN"};